.trend {
	display: inline-flex;
	margin-right: var(--size-2);
	color: var(--color-text-silent);

	&[data-tone="good"] {
		color: var(--color-success-foreground);
	}
	&[data-tone="bad"] {
		color: var(--color-error-foreground);
	}
}

.container {
	background-color: var(--color-surface);
	border-radius: var(--radius-md);
	padding: var(--size-3);
	gap: var(--size-3);
	display: flex;
	text-align: left;
	font-variant-numeric: tabular-nums;
	flex-direction: column;
	width: 100%;

	transition: background-color 0.1s ease;
	&:hover,
	&:focus-visible {
		background-color: var(--color-surface-elevated);
	}

	.head {
		font-weight: 500;
		display: flex;
		width: 100%;
		align-items: center;
		height: 24px;

		.icon {
			flex-shrink: 0;
			width: var(--size-8);
			display: flex;
			justify-content: center;

			transition: transform 0.1s ease;
			&[data-collapsed="true"] {
				transform: rotate(180deg);
			}
		}

		.title {
			/* the stacked breakdown can be wide, so the title is what gives way */
			min-width: 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.breakdown {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
			white-space: nowrap;
			margin-left: var(--size-5);
			gap: var(--size-5);
			font-size: var(--text-caption);
			font-weight: 400;
			color: var(--color-text-subtle);

			/* the shared formatters bundle a trend arrow; one per series is just noise */
			.trend {
				display: none;
			}
		}

		/*
		 * Deliberately not a flex container: `format` emits the number and its unit as
		 * separate text nodes, which a gap would push apart into "60.2 mbps".
		 */
		.tag {
			display: flex;
			align-items: baseline;
			gap: var(--size-2);
			.label {
				font-weight: 500;
				color: var(--color-text);
			}

			&::before {
				content: "";
				width: 8px;
				height: 8px;
				border-radius: 2px;
				corner-shape: round;
				background-color: var(--series-color);
			}
		}

		.total {
			display: inline-flex;
			align-items: center;
			flex-shrink: 0;
			white-space: nowrap;
			/* pinned to the right, with a minimum gap when the title is squeezed */
			margin-left: auto;
			padding-left: var(--size-7);
		}
	}

	.graph {
		border: 1px solid var(--color-border);
		position: relative;
		height: 180px;
		margin-left: var(--size-8);
		margin-bottom: 1lh;
		font-size: var(--text-caption);
		color: var(--color-text-subtle);

		&[data-collapsed="true"] {
			display: none;
		}

		svg {
			position: absolute;
			inset: 0;
			width: 100%;
			height: 100%;
		}
	}
}
